import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { SITE } from "../../lib/site";

const COLS = [
  { h: "Products", links: [
    ["3D Hologram Stickers", "/products/3d-hologram-stickers"],
    ["QR Code Hologram Labels", "/products/qr-code-hologram-labels"],
    ["Tamper-Evident Labels", "/products/tamper-evident-hologram-labels"],
    ["Serial Number Holograms", "/products/serial-number-hologram-stickers"],
    ["Scratch-Off Holograms", "/products/scratch-off-hologram-stickers"],
    ["Custom Security Labels", "/products/custom-security-hologram-stickers"],
  ]},
  { h: "Solutions", links: [
    ["Anti-Counterfeit", "/solutions/anti-counterfeit-labels"],
    ["Product Authentication", "/solutions/product-authentication"],
    ["Brand Protection", "/solutions/brand-protection"],
    ["Tamper Evidence", "/solutions/tamper-evidence"],
    ["QR Verification", "/solutions/qr-verification"],
  ]},
  { h: "Industries", links: [
    ["Pharmaceutical", "/industries/pharmaceutical-hologram-labels"],
    ["Cosmetics", "/industries/cosmetic-security-labels"],
    ["Food & Beverage", "/industries/food-product-security-labels"],
    ["Electronics", "/industries/electronics-security-labels"],
    ["Automotive", "/industries/automotive-security-labels"],
    ["Luxury Products", "/industries/luxury-product-hologram-labels"],
  ]},
  { h: "UAE Locations", links: [
    ["Sharjah", "/locations/sharjah"],
    ["Dubai", "/locations/dubai"],
    ["Abu Dhabi", "/locations/abu-dhabi"],
    ["Ajman", "/locations/ajman"],
    ["Ras Al Khaimah", "/locations/ras-al-khaimah"],
    ["Fujairah", "/locations/fujairah"],
    ["Umm Al Quwain", "/locations/umm-al-quwain"],
    ["Al Ain", "/locations/al-ain"],
  ]},
];

export default function Footer() {
  return (
    <footer className="relative z-10 border-t border-white/10 bg-surface" data-testid="site-footer">
      <div className="px-6 md:px-10 lg:px-16 py-16">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-10">
          <div className="col-span-2">
            <img src="/logo.png?v=2" alt="NanoMax Holo Solutions LLC logo" className="h-14 w-auto mb-5" />
            <p className="text-sm text-[#8A8A9B] max-w-xs leading-relaxed">Advanced hologram &amp; security label solutions for businesses across the UAE.</p>
            <div className="mt-6 space-y-2 text-sm text-[#C9C9D4]">
              <a href={`tel:${SITE.phoneRaw}`} className="flex items-center gap-2 hover:text-holo-cyan transition-colors" data-testid="footer-phone"><Phone size={14} /> {SITE.phone}</a>
              <a href={`mailto:${SITE.email}`} className="flex items-center gap-2 hover:text-holo-cyan transition-colors" data-testid="footer-email"><Mail size={14} /> {SITE.email}</a>
              <div className="flex items-center gap-2"><MapPin size={14} /> {SITE.address}</div>
            </div>
          </div>
          {COLS.map((c) => (
            <div key={c.h}>
              <h3 className="font-mono2 text-[11px] uppercase tracking-[0.18em] text-white mb-4">{c.h}</h3>
              <ul className="space-y-2.5">
                {c.links.map(([label, to]) => (
                  <li key={to}><Link to={to} className="text-[13px] text-[#8A8A9B] hover:text-holo-cyan transition-colors">{label}</Link></li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
          <p className="text-xs text-[#555566] font-mono2">© {new Date().getFullYear()} {SITE.legal}. All rights reserved.</p>
          <Link to="/contact" className="btn-primary px-6 py-3 text-xs" data-testid="footer-cta">Get Your Hologram Sticker Quote</Link>
        </div>
      </div>
    </footer>
  );
}
